<template lang="pug">
.super-card
  .left
    img.icon(v-if="dataForm.prizes[0].icon" :src="dataForm.prizes[0].icon")
    .icon(v-else)
    .content
      .name {{`${dataForm.prizes[0].prizeName}${dataForm.prizeType == 26 ? `+${dataForm.worth}` : ''}`}}
      .date {{ dataForm.batchNo }}
  .status(
    v-if="!dataForm.prizeStatus && layout.includes('activityDesc')"
  ) 活动结束
  .btn(v-else @click="jump") 去查看
  img.tip(
    v-if="dataForm.prizeStatus && layout.includes('activityIcon')"
    src="https://m.hellobike.com/resource/gallery/350/oxQ-Leju_tips.png"
  )
</template>
<script>
export default {
  props: {
    dataForm: {
      type: Object,
      default: () => ({}),
    },
    layout: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {

    };
  },
  watch: {

  },
  methods: {
    jump() {
      this.$emit('handleClick', this.dataForm);
    },
  },
};
</script>
<style lang="less" scoped>
.super-card {
  position: relative;
  width: 3.51rem;
  height: 0.64rem;
  background-color: #fff;
  border-radius: 0.12rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  .left {
    display: flex;
    align-items: center;

    .icon {
      width: 0.52rem;
      height: 0.52rem;
      margin-left: 0.06rem;
      border-radius: 0.06rem;
      background-color: #fff;
    }

    .content {
      margin-left: 0.08rem;

      .name {
        width: 1.9rem;
        height: 0.2rem;
        font-weight: 500;
        font-size: 0.14rem;
        line-height: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .date {
        width: 1.57rem;
        height: 0.17rem;
        font-weight: 400;
        font-size: 0.12rem;
        line-height: 0.17rem;
        color: #879099;
        margin-top: 0.04rem;
      }
    }
  }

  .status {
    width: 0.8rem;
    height: 0.32rem;
    font-weight: 400;
    font-size: 0.14rem;
    display: flex;
    align-items: center;
    color: #879099;
    justify-content: center;
    margin-right: 0.16rem;
  }

  .btn {
    width: 0.54rem;
    height: 0.23rem;
    border-radius: 0.06rem;
    background-color: #ff5526;
    font-weight: 400;
    font-size: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-right: 0.18rem;
  }

  .tip {
    width: 0.58rem;
    height: 0.58rem;
    position: absolute;
    right: 0.69rem;
    top: 0.19rem;
  }
}
</style>
